import { useEffect } from "react";

// Custom hook to update the document title.
const useTitleUpdater = (title?: string) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Friyay`;
    } else {
      document.title = "Friyay";
    }
  }, [title]);
};

export default useTitleUpdater;
